import { motion } from "framer-motion";
import CustomLists from "@/components/elements/CustomLists/CustomLists";
import ImageWithContentLeftForProduct from "@/components/elements/ImageWithContent/ImageWithContentLeftForProduct";
import Table from "@/components/elements/Table/Table";
import TitleBar from "@/components/elements/TitleBar/TitleBar";
import TitleWithContent from "@/components/elements/TitleWithContent/TitleWithContent";
import imgnotavailableImg from '@/assets/images/products/imgnotavailable.png';

const fadeInUp = {
  initial: { opacity: 0, y: 50 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 0.8, ease: "easeOut" },
  viewport: { once: false, amount: 0.2 },
};

const VistaCrackStop = () => {
  return (
    <div className=" 2xl:px-40 xl:px-40 md:px-[3rem] sm:px-5 my-[4rem] ">
      <TitleBar
        title="VISTA CRACK STOP"
        subTitle="(Monofilament Polypropylene Fibres)"
      />

      <motion.div {...fadeInUp}>
        <ImageWithContentLeftForProduct alt="VISTA CRACK STOP"
          imageUrl={imgnotavailableImg}
          title="Description"
          content="The Crack stop range of monofilament polypropylene fibres reduce the occurrence of plastic shrinkage and plastic settlement cracking, whilst enhancing the surface properties and durability of hardened cementitious products. Crack stop fibres are extremely fine, single filaments, cut to lengths of either 3, 6, 12 and 18 mm. Some fibre types also have blended lengths. The fibres are coated with surfactant to improve initial dispersion within the cementitious materials. The Crack stop range of monofilament polypropylene fibres reduce the occurrence of plastic shrinkage and plastic settlement cracking, whilst enhancing the surface properties and durability of hardened cementitious products. Crack stop fibres are extremely fine, single filaments, cut to lengths of either 3, 6, 12 and 18 mm. Some fibre types also have blended lengths. The fibres are coated with surfactant to improve initial dispersion within the cementitious materials."
        />
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Advantages">
          <CustomLists
            items={[
              [
                "Reduced Plastic Shrinkage Cracking",
                "Reduced Explosive Spalling In Fire",
                "Alternative To Crack Control Mesh",
                "Improved Freeze/thaw Resistance",
                "Reduced Water & Chemical Permeability",
              ],
              [
                "Reduced Bleeding",
                "Reduced Plastic Settlement Cracking",
                "Increased Impact Resistance",
                "Increased Abrasion Properties",
              ],
            ]}
          />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Uses">
          <CustomLists
            items={[
              [
                "Internal Floor Slabs",
                "Underground Construction",
                "Concrete Framed Buildings",
                "Agricultural Areas",
                "Water Retaining Structures",
                "Repair Materials",
                "Extruded Concrete",
              ],
              [
                "External Hard Standings",
                "Self Compacting Concrete & Screeds",
                "Bridges",
                "Pattern Imprinted Concrete",
                "Precast Concrete",
                "Piling Concrete",
                "Shotcrete/gunite",
              ],
            ]}
          />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Properties">
          <Table
            items={{
              headings: [],
              rows: [
                ["Materials", "100% virgin polypropylene"],
                ["Design/shape", "Monofilament fibre with a diameter of 22µm max"],
                ["Fibre length", "3, 6, 12, 18 mm nominal or blended lengths"],
                ["Surface", "Coated for dispersion"],
              ],
            }}
          />
        </TitleWithContent>
      </motion.div>
    </div>
  );
};

export default VistaCrackStop;
